export interface Gestor {
    idGestor: number,
    txApellidos: string,
    txNombres: string,
    unidad: string,
    area: string,
    idUnidad: number,
    idArea: number
}

export function GetVoidGestor(): Gestor {
    return {
        idGestor: 0,
        txApellidos: '',
        txNombres: '',
        unidad: '',
        area: '',
        idUnidad: 0,
        idArea: 0
    }
}